<template>
  <div>
    <div :id="playlistId"></div>
    <div class="columns is-mobile is-gapless">
      <div class="column is-2">
        <b-button @click="pause()" class="is-info" expanded outlined>
          <b-icon pack="fas" icon="pause" size="is-small" />
        </b-button>
      </div>
      <div class="column is-2">
        <b-button @click="play()" class="is-success" expanded outlined>
          <b-icon pack="fas" icon="play" size="is-small" />
        </b-button>
      </div>
      <div class="column is-2">
        <b-button @click="stop()" class="is-danger" expanded outlined>
          <b-icon pack="fas" icon="stop" size="is-small" />
        </b-button>
      </div>
      <div class="column is-4">
        <p class="has-text-centered heading">{{ text }}</p>
      </div>
      <div class="column is-1">
        <b-button @click="zoomIn()" class="is-primary" expanded outlined>
          <b-icon pack="fas" icon="search-plus" size="is-small" />
        </b-button>
      </div>
      <div class="column is-1">
        <b-button @click="zoomOut()" class="is-primary" expanded outlined>
          <b-icon pack="fas" icon="search-minus" size="is-small" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import WaveformPlaylist from "waveform-playlist";
import utils from "../services/utils";
export default {
  props: ["src", "from", "to", "text"],
  data() {
    return {
      playlistId: utils.getRandomAudioClass(),
      playlist: undefined,
      ee: undefined
    };
  },
  methods: {
    play() {
      this.ee.emit("play");
    },
    pause() {
      this.ee.emit("pause");
    },
    stop() {
      this.ee.emit("stop");
    },
    zoomIn() {
      this.ee.emit("zoomin");
    },
    zoomOut() {
      this.ee.emit("zoomout");
    }
  },
  mounted() {
    this.playlist = WaveformPlaylist({
      waveHeight: 50,
      state: "select",
      container: document.getElementById(this.playlistId),
      colors: {
        waveOutlineColor: "#E0EFF1"
      },
      timescale: true,
      samplesPerPixel: 1024,
      zoomLevels: [128, 256, 512, 1024, 2048, 4096],
      isAutomaticScroll: true
    });
    this.ee = this.playlist.getEventEmitter();
    this.playlist
      .load([
        {
          src: this.src,
          states: {
            cursor: true,
            select: true,
            shift: false,
            fadein: false,
            fadeout: false
          },
          cuein: this.from,
          cueout: this.to
        }
      ])
      .then(function() {
        //can do stuff with the playlist.
      });
  },
  beforeDestroy() {
    this.stop();
  }
};
</script>

<style lang="scss" scoped>
.player-controls {
  justify-content: right;
}
</style>
